module.exports = __webpack_public_path__ + "img/下一页.65f331ea.png";